export default class Locale_MoveAllResourceRequestsDto {
	SourceResource: string = "Source Resource";
	SourceResourceRequired: string = "Source resource is a required field.";
	TargetResource: string = "Target Resource";
	TargetResourceRequired: string = "Target resource is a required field.";
}